import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { getPurchaseStatus } from '../../apiCalls';
import Loading from '../../components/standard/loading/Loading';

import {
  HeaderAndFooterPayment,
  changeTitle,
  removeOperatorCookies,
  getFiltersFromSession,
  clearFiltersFromSession,
} from '../../utils';
import dataLayer from '../../utils/dataLayer';
import {
  runFacebook,
  runYuhagent,
  runGoogleAdWordsConversion,
  NewRunGoogleAdwordsConversion,
} from '../../SeoFunctions';

// components PurchaseStatus
import StatusBoleto from '../../components/purchase_status/StatusBoleto';
import StatusSafetypay from '../../components/purchase_status/StatusSafetypay';
import StatusCreditCard from '../../components/purchase_status/StatusCreditCard';
import StatusPurchase from '../../components/purchase_status/StatusPurchase';
import StatusInsureds from '../../components/purchase_status/StatusInsureds';
import StatusFooter from '../../components/purchase_status/StatusFooter';
import StatusBoxSuccess from '../../components/purchase_status/StatusBoxSuccess';
import SafeareaBox from '../../components/purchase_status/SafeareaBox';
import StatusPix from '../../components/purchase_status/StatusPix';
import { StatusCreditCoupon } from './status_credit_coupon';
import RaBanner from '../../components/purchase_status/RaBanner';

export class PostPurchase extends Component {
  POLL_INITIAL_INTERVAL = 15000;
  POLL_MAX_INTERVAL = 60000;
  POLL_MAX_DURATION = 20 * 60000;

  pollingTimer = null;
  pollingStart = null;
  pollingInterval = this.POLL_INITIAL_INTERVAL;
  pollingStarted = false;

  constructor(props) {
    super(props);
    changeTitle('purchase');
  }

  startPolling = () => {
    this.pollingStart = Date.now();
    this.pollingInterval = this.POLL_INITIAL_INTERVAL;
    this.scheduleNextPoll();
  };

  scheduleNextPoll = () => {
    const elapsed = Date.now() - this.pollingStart;
    if (elapsed >= this.POLL_MAX_DURATION) return;

    const remaining = this.POLL_MAX_DURATION - elapsed;
    const delay = Math.min(this.pollingInterval, remaining);

    this.pollingTimer = setTimeout(() => {
      getPurchaseStatus(this.props.match.params.uuid);
      this.pollingInterval = Math.min(this.pollingInterval * 2, this.POLL_MAX_INTERVAL);
      this.scheduleNextPoll();
    }, delay);
  };

  stopPolling = () => {
    if (this.pollingTimer) {
      clearTimeout(this.pollingTimer);
      this.pollingTimer = null;
    }
  };

  componentWillMount() {
    getPurchaseStatus(this.props.match.params.uuid);
    HeaderAndFooterPayment(this.props.location.pathname);
  }

  componentDidMount() {
    removeOperatorCookies();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.purchase.id && this.props.purchase.id) {
      const p = this.props.purchase;
      dataLayer.pageView('checkout_confirmacao');
      dataLayer.purchase(
        { id: p.id, grandTotal: p.price, coupon: p.coupon_code, discount: p.discount },
        { code: p.product_id, name: p.product, provider_code: p.provider, price_with_coupon_discount: p.price },
        p.insureds ? p.insureds.length : 1,
        p.payment_method
      );
      runYuhagent(p.price, p.id);
    }
  }

  componentWillUnmount() {
    this.stopPolling();
    const compHeader = document.getElementsByClassName('comp_header clearfixs');
    if (compHeader.length > 0) {
      compHeader[0].style = 'position: static';
    }
  }

  componentWillReceiveProps(nextProps) {
    const { purchase, mobile } = nextProps;

    const isPix = purchase.payment_method === 'PIX';
    const isPending = purchase.payment_status === 'Pendente';

    if (isPix && isPending && !this.pollingStarted) {
      this.pollingStarted = true;
      this.startPolling();
    } else if (this.pollingStarted && purchase.payment_status && !isPending) {
      this.stopPolling();
    }

    dataLayer.raw({
      event: 'checkout',
      ecommerce: {
        checkout: {
          actionField: {
            step: purchase.parcels,
            option: purchase.payment_method,
            coupon_code: purchase.coupon_code,
          },
          products: [
            {
              name: purchase.product,
              id: purchase.id,
              price: purchase.price,
              brand: purchase.provider,
              device: mobile ? 'mobile' : 'desktop',
              quantity: 1,
            },
          ],
        },
      },
    });

    const selectedFilters = getFiltersFromSession();

    if (selectedFilters) {
      clearFiltersFromSession();
    }
  }

  boxPayment = (purchase) => {
    if (purchase.price === 0) {
      return <div />;
    }

    if (purchase.payment_method === 'Cartão de Crédito') return <StatusCreditCard purchase={purchase} />;
    else if (purchase.payment_method === 'Boleto') return <StatusBoleto purchase={purchase} />;
    else if (purchase.payment_method === 'Transferência Bancária') return <StatusSafetypay purchase={purchase} />;
    else if (purchase.payment_method === 'PIX') return <StatusPix purchase={purchase} />;
    else return <div />;
  };

  render() {
    if (this.props.loading) return <Loading />;

    if (!this.props.purchase.id) return null;

    const { price, id } = this.props.purchase;

    runGoogleAdWordsConversion(id, price);
    NewRunGoogleAdwordsConversion(id);

    runFacebook('Purchase', {
      value: price,
      currency: 'BRL',
      contents: [
        {
          id,
        },
      ],
    });

    // Matomo track order
    const order = {
      id: id,
      grandTotal: price,
      subTotal: 0,
      discount: this.props.purchase.discount || 0,
    };

    const destinationObj =
      this.props.destination && this.props.destination.find((dest) => dest.name === this.props.purchase.destination);
    const destinationSlug = destinationObj ? destinationObj.slug : this.props.purchase.destination;

    const items = [
      {
        sku: this.props.purchase.product_id,
        name: this.props.purchase.product,
        category: destinationSlug,
        price: price,
        quantity: this.props.purchase.insureds.length,
      },
    ];

    if (this.props.mobile) {
      const compHeader = document.getElementsByClassName('comp_header payment');
      if (compHeader && compHeader.length) {
        compHeader[0].style = 'display: block; height: 68px;';
      }
    }

    const { purchase } = this.props;

    return (
      <div className="container-status">
        <StatusBoxSuccess purchase={purchase} />
        <SafeareaBox />
        <RaBanner />
        {this.boxPayment(purchase)}
        {purchase.credit_coupon && (
          <StatusCreditCoupon creditCoupon={purchase.credit_coupon} createdAt={purchase.created_at} />
        )}
        <StatusPurchase purchase={purchase} />
        <StatusInsureds insureds={purchase.insureds} />
        <StatusFooter purchase={purchase} />
      </div>
    );
  }
}

const PostPurchaseWithFeature = (props) => {
  return <PostPurchase {...props} />;
};

export default connect(
  (state) => ({
    loading: state.purchaseStatus.loading,
    purchase: state.purchaseStatus,
    mobile: state.mobile.mobileActive,
    destination: state.global.destinations,
  }),
  {}
)(withRouter(PostPurchaseWithFeature));



// WEBPACK FOOTER //
// ./src/views/purchase_status/PurchaseStatus.jsx